import type { ElementType } from 'react';
import MUIIconButton, {
  IconButtonProps as MUIIconButtonProps,
  IconButtonTypeMap as MUIIconButtonTypeMap,
} from '@mui/material/IconButton';
import { alpha, styled } from '../styles';
import Tooltip from '../Tooltip';

const IconButtonStyled = styled(MUIIconButton)(({ theme: { palette } }) => ({
  '& .MuiSvgIcon-root': {
    color: palette.icon.onMain,
  },
  '&.Mui-disabled .MuiSvgIcon-root': {
    color: palette.icon.disabled,
  },
  '&:hover': {
    backgroundColor: alpha(palette.interaction.hover, 0.16),
    '.MuiSvgIcon-root': {
      color: palette.icon.onMainHighlighted,
    },
  },
  '&:focus': {
    backgroundColor: alpha(palette.interaction.hover, 0.32),
    '.MuiSvgIcon-root': {
      color: palette.icon.onMainHighlighted,
    },
  },
}));

const IconButton = ({ tooltip, children, disabled, ref, ...otherProps }: Props) => {
  const icon = (
    <IconButtonStyled {...otherProps} ref={ref} disabled={disabled}>
      {children}
    </IconButtonStyled>
  );

  return disabled ? (
    icon
  ) : (
    <Tooltip title={tooltip}>
      <span>{icon}</span>
    </Tooltip>
  );
};

export type Props<D extends ElementType = MUIIconButtonTypeMap['defaultComponent']> =
  MUIIconButtonProps<D, { component?: D }> & {
    tooltip: string;
  };

export default IconButton;
